const PHONE_PAT = /^([0-9()+ -]*)$/;
const CYR_PAT = /^[А-ЯЁ\-\s]+$/gim;
const LAT_PAT = /^[A-Z\-\s]+$/gim;
const MAIL_PAT =
  // eslint-disable-next-line no-useless-escape, no-control-regex
  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
const SYMBOLS_PAT = /\D/g;
const SPACE_PAT = /\s/g;
const BIRTHDATE_PAT = /^([0|1|2][0-9]|3[01])(0[0-9]|1[012])[0-9]{4}$/g;
const MAX_EMAIL_LENGTH = 320;
const Today = new Date();

const isRequired = (v) => v != null && v !== '' && v !== false;
const isPhone = (v) => {
  const value = v.replace(SYMBOLS_PAT, '');

  return value.length >= 11 && value.length <= 14 && value.match(PHONE_PAT);
};

const isEmail = (v) => v.length <= MAX_EMAIL_LENGTH && v.match(MAIL_PAT);
const isCyrilic = (v) => v.match(CYR_PAT);
const isLatin = (v) => v.match(LAT_PAT);

const validatePassnumber = (passnumber) => {
  const num = passnumber.replace(SPACE_PAT, '');

  if (num.length === 0) {
    return false;
  }

  return true;
};

const validateBirthDate = (bithdate) => {
  const date = bithdate.replace(SYMBOLS_PAT, '');

  if (date.length < 8) {
    return false;
  }

  if (!date.match(BIRTHDATE_PAT)) {
    return false;
  }

  const day = +date.substr(0, 2);
  const month = +date.substr(2, 2) - 1;
  const year = +date.substr(4, 4);

  if (day > 31 || month > 11 || year < 1906) {
    return false;
  }

  if (Today.getTime() - new Date(year, month, day).getTime() < 0) {
    return false;
  }

  return true;
};

const isNonEmpty = (v) => !!(v && v.trim ? v.trim() : v);

const isDifferentDirections = (value, { fromCode, toCode }) => fromCode !== toCode;

export {
  isRequired,
  isPhone,
  isEmail,
  isCyrilic,
  isDifferentDirections,
  isNonEmpty,
  isLatin,
  validatePassnumber,
  validateBirthDate,
};

export default {
  isRequired,
  isPhone,
  isEmail,
  isCyrilic,
  isDifferentDirections,
  isNonEmpty,
  isLatin,
  validatePassnumber,
  validateBirthDate,
};
